import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import log from 'client/lib/log';

const debug = log.debug('sunroom:components:OpenPlaidLink');

const OpenPlaidLink = ({ linkToken, receivedRedirectUri, onSuccess, onExit }) => {
  debug({ linkToken });
  const config = {
    token: linkToken,
    receivedRedirectUri,
    onSuccess,
    onExit,
  };

  const { open, ready } = usePlaidLink(config);

  useEffect(() => {
    if (!ready) {
      return;
    }
    open();
  }, [ready, open]);

  return null;
};

OpenPlaidLink.propTypes = {
  linkToken: PropTypes.string.isRequired,
  receivedRedirectUri: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
};

OpenPlaidLink.displayName = 'OpenPlaidLink';

export default OpenPlaidLink;
